import { decrypt } from "../utils/enkripsi";
import { showLog } from "../utils/log";
import FETCH_API from "./fetch_api";

export async function send_email(params) {
  showLog("Config Masuk send_email");
  const result = await FETCH_API(
    "send_email_v2/afterPayment",
    params,
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImlyZmFuIiwiaWF0IjoxNjI1MjA0NTQ2LCJleHAiOjE2MjUzODA5NDZ9.pd_86GRYqBZzAhccYtXkydh-dlXesj2B6Ec5HexO4f4"
  );
  return result;
}

export async function proses_data() {
  showLog("Config Masuk proses_data");
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  const id = JSON.parse(localStorage.getItem("dataBranch"));
  let users = {};
  let url = "process-web";
  if (localStorage.getItem("login")) {
    users.nama = JSON.parse(localStorage.getItem("login")).nama;
  } else {
    users.nama = JSON.parse(localStorage.getItem("orderDate")).nama;
  }
  let body = {
    from_origin: "*",
    userServer: userServer,
    transCode: "si",
    transId: id.detailData,
    userId: "admin",
  };
  const process = await FETCH_API(url, body);
  return process;
}

export async function onSave(state) {
  showLog("Config Masuk onSave");
  const safeJsonParse = (value) => {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (_) {
      return null;
    }
  };

  const safeDecryptFromStorage = (key) => {
    try {
      const parsed = safeJsonParse(localStorage.getItem(key));
      return decrypt(parsed);
    } catch (_) {
      return null;
    }
  };

  const userServer = safeJsonParse(localStorage.getItem("userServer"));
  const dataBranch = safeJsonParse(localStorage.getItem("dataBranch"));
  let dataDetailData = safeDecryptFromStorage("detailData");
  let detailTrans = safeDecryptFromStorage("detailTrans");
  let chargesNote = safeDecryptFromStorage("chargesNote");

  if (!userServer) {
    return {
      status: "ERROR",
      message:
        "userServer belum tersedia. Silakan refresh halaman atau scan ulang QR.",
    };
  }

  if (!dataBranch || !dataBranch.detailData) {
    return {
      status: "ERROR",
      message:
        "Data cabang/transaksi tidak ditemukan. Silakan ulangi dari halaman sebelumnya.",
    };
  }

  if (!dataDetailData || typeof dataDetailData !== "object" || Array.isArray(dataDetailData)) {
    return {
      status: "ERROR",
      message:
        "Detail transaksi tidak ditemukan atau rusak (detailData kosong). Silakan ulangi pemesanan.",
    };
  }

  if (!Array.isArray(detailTrans)) {
    detailTrans = detailTrans ? [detailTrans] : [];
  }

  if (!Array.isArray(chargesNote)) {
    chargesNote = chargesNote ? [chargesNote] : [];
  }

  dataDetailData["customer_id"] = "URUZ-TABLE-QR";
  dataDetailData["id"] = dataBranch.detailData;
  let type = localStorage.getItem("type");
  let url = "trans-s-si-web/update-v2";
  let transMode = "edit";
  let deleteDetailTrans = false;
  if (type == "takeaway") {
    url = "trans-s-si-web/save";
    if (state == "save") {
      transMode = "new";
    }
    if (state == "proses") {
      transMode = "edit";
    }
  }
  if (type == "tableQR") {
    url = "trans-s-si-web/update-v2";
    if (state == "proses") {
      detailTrans = detailTrans ? detailTrans : [];
      deleteDetailTrans = true;
    }
  }
  let body = {
    from_origin: "*",
    userServer: userServer,
    transMode: transMode,
    userId: "admin",
    detailData: JSON.stringify(dataDetailData),
    detailTrans: JSON.stringify(detailTrans),
    discountsNote: "[]",
    chargesNote: JSON.stringify(chargesNote || []),
    deleteDetailTrans: deleteDetailTrans,
  };

  console.log("INI BODY onSave = ", {
    from_origin: "*",
    userServer: userServer,
    transMode: transMode,
    userId: "admin",
    detailData: dataDetailData,
    detailTrans: detailTrans,
    discountsNote: "[]",
    chargesNote: chargesNote || [],
    deleteDetailTrans: deleteDetailTrans,
  })

  const result = await FETCH_API(url, body);
  return result;
}

export async function onSaveCustomer() {
  showLog("Config Masuk onSaveCustomer");
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  let dataDetailDataCustomer = decrypt(
    JSON.parse(localStorage.getItem("detailDataCustomer"))
  );
  let url = "mas_guest/saveTableQRGuest";
  let body = {
    from_origin: "*",
    userServer: userServer,
    userId: "admin",
    detailData: [dataDetailDataCustomer],
    mode: "insert",
  };
  const result = await FETCH_API(url, body);
  return result;
}

export async function getTabSetting(id) {
  showLog("Config Masuk getTabSetting");
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  let url = "settings/get1TabSetting";
  let body = {
    from_origin: "*",
    userServer: userServer,
    id: id,
    isTableQRcustomer: true,
  };
  const result = await FETCH_API(url, body);
  return result;
}
